<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import groupBy from "lodash/groupBy";
import PropertyUpdate from "@/components/modals/property-create.vue";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import Campus from "@/components/modals/campus.vue";
import Disposal from "@/components/modals/supply-disposal.vue";
import Details from "@/router/views/property/components/details";
import AssignmentHistory from "@/router/views/property/components/assignmenthistory";
import Attachments from "@/router/views/property/components/attachments";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Un-assigned",
  },
  components: {
    Layout,
    PageHeader,
    PropertyUpdate,
    FundCluster,
    ItemCategory,
    Supplier,
    Unit,
    Employee,
    Campus,
    Location,
    Disposal,
    Details,
    AssignmentHistory,
    Attachments,
    RawData,
  },
  data() {
    return {
      title: "Un-assigned",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Un-assigned",
          active: true,
        },
      ],
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptionsLg: [10, 25, 50, 100],
      pageOptionsSm: [5, 10, 20, 50],
      filter: "",
      searchInput: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      assignmentNumber: true,
      fields: [
        {
          key: "poNumber",
          sortable: true,
          label: "Purchase Order",
        },
      ],
      propertyFields: [
        {
          key: "Name",
          sortable: true,
        },
      ],
      formMultiple: {
        properties: [],
        assignmentNumber: "",
        employeeIdNumber: "",
        assignNotes: "",
        assignmentType: "",
        location: "",
        locationId: 0,
        renewalDate: "",
        toggleAll: false,
      },
      byFiltered: false,
      getEmployeeType: "",
      getLocationType: "",
      getLocationItem: null,
      poIndex: -1,
      propertyIndex: -1,
      tableBusy: false,
      employeeName: "",
      campus: "",
      campusSelected: null,
      location: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null,
      campusId: this.$store.state.data.selectedCampus.id,
      tabIndex: 0,
      selectedProperties: [],
      perPageCart: 10,
      currentPageCart: 1,
      filterCart: "",
      mouseOverCart: false,
    };
  },
  computed: {
    grouped() {
      if (this.byFiltered) {
        var array = [];
        var x = groupBy(this.filtered, "supplier");
        for (const key in x) {
          var supplier = key;
          var y = groupBy(x[key], "poNumber");
          for (const key in y) {
            array.push({
              poNumber: key,
              supplier: supplier,
              details: y[key],
              showDetails: false,
              rotateChevy: false,
              currentPage: 1,
              perPage: 5,
              filter: "",
              tableBusy: false,
            });
          }
        }
        return array;
      } else return this.filtered;
    },
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.poNumber.toUpperCase().includes(this.filter.toUpperCase())) {
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
          if (item.supplier.toUpperCase().includes(this.filter.toUpperCase())) {
            return item.supplier
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
          if (item.name.toUpperCase().includes(this.filter.toUpperCase())) {
            return item.name.toUpperCase().includes(this.filter.toUpperCase());
          }
          if (
            item.propertyNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
          if (
            item.serialNumber.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
          if (
            item.currentAssignment &&
            item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      return this.grouped.length;
    },
    filteredCart() {
      let data = this.selectedProperties;
      if (this.filterCart.trim() != "" && this.filterCart) {
        data = data.filter((item) => {
          if (item.name.toUpperCase().includes(this.filterCart.toUpperCase())) {
            return item.name
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          } else if (
            item.propertyNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase())
          ) {
            return item.propertyNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          } else if (
            item.serialNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase())
          ) {
            return item.serialNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          } else if (
            item.currentAssignment &&
            item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase())
          ) {
            return item.currentAssignment.assignmentNumber
              .toUpperCase()
              .includes(this.filterCart.toUpperCase());
          }
        });
      }
      return data;
    },
    rowsCart() {
      if (this.filterCart.trim() != "" && this.filterCart) {
        return this.filteredCart.length;
      } else {
        return this.selectedProperties.length;
      }
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      this.getAvailable();
    },
    getAvailable() {
      this.totalRows = this.items.length;
      this.tableBusy = true;
      this.$store
        .dispatch("property/GetPropertyAvailable", this.campusId)
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.visible = false;
            item.itemVisible = false;
            item.assignmentHistory = [];
            item.assignVisible = false;
            item.assignLoading = false;
            item.attachmentVisible = false;
            item.addDocu = false;
            item.attachmentLoading = false;
            item.fileSearch = "";
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting un-assigned list!",
            "error"
          );
        });
    },
    propertyFiltered(row) {
      if (row.showDetails) {
        let data = row.details;
        if (row.filter.trim() != "" && row.filter) {
          data = data.filter((item) => {
            if (item.name.toUpperCase().includes(row.filter.toUpperCase())) {
              return item.name.toUpperCase().includes(row.filter.toUpperCase());
            } else if (
              item.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase())
            ) {
              return item.propertyNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            } else if (
              item.serialNumber.toUpperCase().includes(row.filter.toUpperCase())
            ) {
              return item.serialNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            } else if (
              item.currentAssignment &&
              item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase())
            ) {
              return item.currentAssignment.assignmentNumber
                .toUpperCase()
                .includes(row.filter.toUpperCase());
            }
          });
        }
        return data;
      } else return [];
    },
    propertyRows(row) {
      if (row.filter.trim() != "" && row.filter) {
        return this.propertyFiltered(row).length;
      } else {
        return row.details.length;
      }
    },
    onUpdateItem(props) {
      props.visible = false;
      props.itemVisible = false;
      props.assignmentHistory = [];
      props.assignVisible = false;
      props.assignLoading = false;
      props.attachmentVisible = false;
      props.addDocu = false;
      props.attachmentLoading = false;
      props.fileSearch = "";
      this.tableData.splice(this.propertyindex, 1, props);
    },
    updateItem(props) {
      this.propertyIndex = this.tableData.findIndex(
        (item) => item.id == props.id
      );
      this.$refs.propertyupdate.updateProperty(props.id);
    },
    onAddMultiple() {
      this.submitted = true;
      if (this.checkMultiple()) return;
      else {
        this.$swal({
          title: "Are you sure?",
          text: `${this.formMultiple.properties.length} ${this.formMultiple.properties.length > 1 ? "properties" : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, assign items!",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch(
                "propertyassignment/AddMultiplePropertyAssignment",
                this.formMultiple
              )
              .then((res) => {
                this.formMultiple.properties.forEach((property) => {
                  var mainIndex = this.tableData.findIndex(
                    (item) => item.id == property.propertyId
                  );
                  this.tableData.splice(mainIndex, 1);

                  var cartIndex = this.selectedProperties.findIndex(
                    (item) => item.id == property.propertyId
                  );
                  this.selectedProperties.splice(cartIndex, 1);
                });
                this.$bvModal.hide("modal-multiple");
                this.showToast("Successfully assigned!", "success");
              })
              .catch((err) => {
                this.showToast(
                  "Something went wrong - Assigning property!",
                  "error"
                );
              });
          }
        });
        this.submitted = false;
      }
    },
    onReset() {
      this.submitted = false;
      this.formMultiple = {
        properties: [],
        assignmentNumber: "",
        employeeIdNumber: "",
        assignNotes: "",
        assignmentType: "",
        location: "",
        locationId: 0,
        toggleAll: false,
      };
      this.employeeName = "";
      this.location = "";
    },
    assignProperty(data) {
      var index = this.tableData.findIndex(
        (item) => item.id == data.propertyId
      );
      this.tableData.splice(index, 1);
    },
    assignMultiple() {
      this.onReset();
      this.filteredCart.forEach((item) => {
        this.formMultiple.properties.push({
          propertyId: item.id,
          name: item.name,
          propertyNumber: item.propertyNumber,
          propertyLocationId: null,
          location: "",
          toggleSelected: false,
        });
      });
      this.modalTitle = "Assign Officer";
      this.$bvModal.show("modal-multiple");
    },
    onTransfer() {
      this.submitted = true;
      if (this.campusSelected) {
        var campusId = this.campusSelected.id;
        var propertyIds = [];
        this.formMultiple.properties.forEach((item) => {
          propertyIds.push(item.propertyId);
        });
        this.$swal({
          title: "Are you sure?",
          text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
            } selected.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, transfer items!",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$store
              .dispatch("property/PropertyTransfer", { propertyIds, campusId })
              .then((res) => {
                this.campusSelected = null;
                this.campus = "";
                this.formMultiple.properties.forEach((property) => {
                  var mainIndex = this.tableData.findIndex(
                    (item) => item.id == property.propertyId
                  );
                  this.tableData.splice(mainIndex, 1);

                  var cartIndex = this.selectedProperties.findIndex(
                    (item) => item.id == property.propertyId
                  );
                  this.selectedProperties.splice(cartIndex, 1);
                });
                this.submitted = false;
                this.$bvModal.hide("modal-transfer");
                this.showToast("Successfully transferred", "success");
              })
              .catch((err) => {
                this.showToast("Cannot be transferred!", "error");
              });
          }
        });
      } else return;
    },
    transferCampus() {
      this.campus = "";
      this.campusSelected = null;
      this.submitted = false;
      this.onReset();
      this.filteredCart.forEach((item) => {
        this.formMultiple.properties.push({
          propertyId: item.id,
          name: item.name,
          propertyLocationId: null,
          location: "",
          toggleSelected: false,
        });
      });
      this.modalTitle = `Transfer ${this.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office"}`;
      this.$bvModal.show("modal-transfer");
    },
    disposeMultipleItems() {
      this.onReset();
      this.filteredCart.forEach((item) => {
        this.formMultiple.properties.push({
          disposalId: 0,
          propertyId: item.id,
          name: item.name,
          propertyNumber: item.propertyNumber,
          accumulatedDepreciation: 0,
          accumulatedImpairmentLosses: 0,
          carryingAmount: 0,
          appraisedValue: 0,
          propertyFinalStatus: "",
          inspectionDate: "0001-01-01T00:00:00",
          inspectedBy: "",
          remarks: ""
        });
      });
      this.$refs.disposal.setDisposal(this.formMultiple.properties);
    },
    inspectMultipleItems(props) {
      var propertyIds = [];
      this.filteredCart.forEach((item) => {
        propertyIds.push(item.id);
      });
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"
          } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, set for inspection!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/DisposalMultipleProperty", propertyIds)
            .then((res) => {
              props.forEach((property) => {
                var mainIndex = this.tableData.findIndex(
                  (item) => item.id == property.id
                );
                this.tableData.splice(mainIndex, 1);

                var cartIndex = this.selectedProperties.findIndex(
                  (item) => item.id == property.id
                );
                this.selectedProperties.splice(cartIndex, 1);
              });
              this.showToast("Successfully disposed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be disposed!", "error");
            });
        }
      });
    },
    checkMultiple() {
      var error = 0;
      if (
        this.formMultiple.employeeIdNumber == "" ||
        this.formMultiple.employeeIdNumber == null ||
        this.formMultiple.assignmentType == "" ||
        this.formMultiple.assignmentType == null
      )
        error++;
      this.formMultiple.properties.forEach((item) => {
        if (item.propertyLocationId == null) error++;
      });
      if (error > 0) return true;
      else return false;
    },
    disposeItem(props) {
      var index = this.tableData.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You are about to set this item for inspection.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, dispose it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/DisposeProperty", props.id)
            .then((res) => {
              this.tableData.splice(index, 1);
              this.showToast("Successfully disposed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be disposed!", "error");
            });
        }
      });
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      var firstname = data.firstName;
      var lastname = data.lastName;
      if (this.getEmployeeType == "assign") {
        this.formMultiple.employeeIdNumber = data.idNo;
        this.employeeName = firstname.concat(" ", lastname);
      } else {
        this.assignmentHistoryEmployeeData = data;
      }
    },
    getCampus() {
      this.$refs.campus.getData();
      this.$bvModal.show("campus-modal");
    },
    dropCampus(data) {
      this.campusSelected = data;
      this.campus = data.campusName;
    },
    getLocation(type, item) {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
      this.getLocationType = type;
      this.getLocationItem = item ? item : null;
    },
    dropLocation(data) {
      if (this.getLocationType == "get") {
        if (this.getLocationItem) {
          this.getLocationItem.propertyLocationId = data.location.id;
          this.getLocationItem.location = data.location.location;
        } else {
          this.formMultiple.location = data.location.location;
          this.formMultiple.locationId = data.location.id;
          this.formMultiple.properties.forEach((item) => {
            item.propertyLocationId = data.location.id;
            item.location = data.location.location;
          });
        }
      } else {
        this.assignmentHistoryLocationData = data;
      }
    },
    removeLocation(item) {
      this.formMultiple.location = null;
      this.formMultiple.locationId = "";
      item.propertyLocationId = null;
      item.location = "";
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      row.item.showDetails = !row.item.showDetails;
    },
    searchDtls(row) {
      row.item.rotateChevy = true;
      if (!row.item.showDetails) {
        row.toggleDetails();
        setTimeout(() => {
          row.item.showDetails = true;
        }, 50);
      }
    },
    showCart() {
      this.$bvModal.show("modal-cart");
    },
    addAllToCart(data, currentPage, perPage) {
      var total = currentPage * perPage;
      var currentData = data.slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = data.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        if (this.checkCart(item)) {
          this.selectedProperties.push(item);
          count = count + 1;
        }
      });
      if (count > 0) {
        this.showToast(
          `All visible properties in page ${currentPage} are added to cart.`,
          "info"
        );
      } else {
        this.showToast(
          `All visible properties in page ${currentPage} has already been added to cart.`,
          "warning"
        );
      }
    },
    addToCart(row) {
      this.selectedProperties.push(row);
    },
    removeAllFromCart(data, currentPage, perPage) {
      var total = currentPage * perPage;
      var currentData = data.slice(total - perPage, total);
      if (currentPage > 1 && currentData.length == 0) {
        total = (currentPage - 1) * perPage;
        currentData = data.slice(total - perPage, total);
      }
      var count = 0;
      currentData.forEach((item) => {
        var index = this.selectedProperties.findIndex((x) => x.id == item.id);
        if (index != -1) {
          this.selectedProperties.splice(index, 1);
          count = count + 1;
        }
      });
      if (count > 0) {
        this.showToast(
          `All visible properties in page ${currentPage} are removed from cart.`,
          "error"
        );
      } else {
        this.showToast(
          `All visible properties in page ${currentPage} are not yet added in cart.`,
          "warning"
        );
      }
    },
    removeFromCart(row) {
      var index = this.selectedProperties.findIndex((x) => x.id == row.id);
      this.selectedProperties.splice(index, 1);
      if (this.selectedProperties.length == 0) this.$bvModal.hide("modal-cart");
    },
    clearCart() {
      this.selectedProperties = [];
      this.$bvModal.hide("modal-cart");
      this.showToast("Cart Cleared!", "error");
    },
    checkCart(row) {
      var index = this.selectedProperties.findIndex((x) => x.id == row.id);
      if (index == -1) return true;
      else return false;
    },
    setYearlyDepreciation(row) {
      if (this.getExactAmt(row.lifespanInYears) > 0)
        return (
          (this.getExactAmt(row.amount) - this.getExactAmt(row.salvageValue)) /
          this.getExactAmt(row.lifespanInYears)
        );
      else return 0;
    },
    propertyNumberWidth(number) {
      if (number < 100) return "min-width: 35px";
      else if (number < 1000) return "min-width: 50px";
      else if (number < 10000) return "min-width: 60px";
      else return "min-width: 75px";
    },
  },
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Assign Multiple -->
    <b-modal id="modal-multiple" :title="modalTitle" size="lg" title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onAddMultiple" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="autoGenerate" checked="checked" class="form-check-input"
              v-model="assignmentNumber" /><label for="autoGenerate" class="form-check-label">
              Auto Generate PAR/ICS Number
            </label>
          </div>
        </div>
        <b-collapse :visible="!assignmentNumber">
          <div v-if="!assignmentNumber" class="mb-3">
            <label for="assignmentNumber">PAR/ICS Number </label>
            <input id="assignmentNumber" type="text" v-model="formMultiple.assignmentNumber"
              placeholder="Enter PAR/ICS Number..." class="form-control" autocomplete="off" />
          </div>
        </b-collapse>
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('assign')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Search Employee..." class="form-control" :class="{
              'is-invalid':
                submitted &&
                (formMultiple.employeeIdNumber == null ||
                  formMultiple.employeeIdNumber == ''),
            }" v-model="employeeName" />
          </b-input-group>
          <div v-if="
            submitted &&
            (formMultiple.employeeIdNumber == null ||
              formMultiple.employeeIdNumber == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select class="form-select" :class="{
            'is-invalid':
              submitted &&
              (formMultiple.assignmentType == null ||
                formMultiple.assignmentType == ''),
          }" v-model="formMultiple.assignmentType">
            <b-form-select-option value="" disabled>Select Type...</b-form-select-option>
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation">Donation</b-form-select-option>
            <b-form-select-option value="Reassignment">Reassignment</b-form-select-option>
            <b-form-select-option value="Relocate">Relocate</b-form-select-option>
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div v-if="
            submitted &&
            (formMultiple.assignmentType == null ||
              formMultiple.assignmentType == '')
          " class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignNotes">Notes </label>
          <textarea id="assignNotes" rows="2" v-model="formMultiple.assignNotes" placeholder="Enter Notes..."
            class="form-control" autocomplete="off"></textarea>
        </div>
        <div class="mb-3">
          <label>Bulk Assign Location</label>
          <b-input-group>
            <template #append>
              <b-button @click="getLocation('get')" variant="outline-info"><i
                  class="mdi mdi-clipboard-text-search-outline"></i></b-button>
            </template>
            <input autocomplete="off" type="text" disabled placeholder="Assign location to all items"
              class="form-control" v-model="formMultiple.location" />
          </b-input-group>
        </div>
        <div class="mb-3">
          <hr class="my-2" />
          <div style="max-height: 180px; overflow: auto" class="pe-2">
            <table width="100%">
              <tbody>
                <tr v-for="(item, index) in formMultiple.properties" :key="index">
                  <td class="py-2">
                    <div class="d-flex">
                      <div class="me-3">{{ index + 1 }}.</div>
                      <div>
                        <div>{{ item.name }}</div>
                        <small>{{ item.propertyNumber }}</small>
                      </div>
                    </div>
                  </td>
                  <td style="width: 50%" class="py-2">
                    <b-input-group>
                      <template #append>
                        <b-button v-if="item.propertyLocationId == null" @click="getLocation('get', item)"
                          variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                        <b-button v-else @click="removeLocation(item)" variant="outline-danger"><i
                            class="mdi mdi-close-thick"></i></b-button>
                      </template>
                      <input autocomplete="off" type="text" disabled class="form-control form-control-sm" :class="{
                        'is-invalid':
                          submitted && item.propertyLocationId == null,
                      }" v-model="item.location" />
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="my-2" />
        </div>
        <div class="d-flex float-end mt-2 mb-2">
          <button type="submit" class="btn btn-primary">Assign</button>
        </div>
      </form>
    </b-modal>
    <!-- Transfer Campus -->
    <b-modal id="modal-transfer" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <label for="supplier">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
      <b-input-group>
        <template #append>
          <b-button @click="getCampus" variant="outline-info" :title="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"><i
              class="mdi mdi-clipboard-text-search-outline"></i></b-button>
        </template>
        <input autocomplete="off" type="text" :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" disabled class="form-control" :class="{
          'is-invalid': submitted && campus == '',
        }" v-model="campus" />
      </b-input-group>
      <div v-if="submitted && campus == ''" class="invalid-feedback">
        <span>This value is required.</span>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary mt-3" type="button" id="inputGroupFileAddon04" @click="onTransfer">
          Transfer
        </button>
      </div>
    </b-modal>
    <!-- Cart -->
    <b-modal id="modal-cart" :title="`Cart: ${selectedProperties.length}
        ${selectedProperties.length > 1 ? 'Properties' : 'Property'}`" size="xl" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex justify-content-between align-items-center">
          <button type="button" class="btn btn-success me-1 d-flex align-items-center" @click="assignMultiple()">
            <i class="bx bx-list-check fs-6 me-1"></i>
            Assign Accountable Officer
          </button>
          <button type="button" class="btn btn-warning me-1 d-flex align-items-center" @click="transferCampus()">
            <i class="bx bx-transfer fs-6 me-1"></i>
            Transfer Campus
          </button>
          <button type="button" class="btn btn-danger me-1 d-flex align-items-center" @click="disposeMultipleItems()">
            <i class="bx bx-trash fs-6 me-1"></i>
            Set for Disposal
          </button>
        </div>
        <div class="d-flex align-items-center">
          <b-button title="Remove All from Cart" class="me-2" @click="clearCart()" variant="outline-danger"><i
              class="mdi mdi-cart-remove"></i></b-button>
          <b-form-input autocomplete="off" v-model="filterCart" type="search" @input="currentPageCart = 1"
            placeholder="Search Properties..." class="form-control"></b-form-input>
        </div>
      </div>
      <div class="custom-table-responsive mb-0">
        <b-table class="propertyTable datatables target-table" thead-class="d-none" :items="filteredCart"
          :fields="propertyFields" responsive="sm" :per-page="perPageCart" :current-page="currentPageCart" sort-by="id"
          :sort-desc.sync="sortDesc" :busy="false" show-empty>
          <template #empty>
            <b-card-header>
              <div class="text-center">
                <div v-if="filterCart != ''">
                  <i class="fas fa-exclamation-triangle me-2"></i>There are no
                  properties matching your request
                </div>
                <div v-else>
                  <i class="fas fa-exclamation-triangle me-2"></i>No properties
                  available
                </div>
              </div>
            </b-card-header>
          </template>
          <template #table-busy>
            <b-card-header>
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </b-card-header>
          </template>
          <template #cell(name)="propertyRow">
            <div class="position-relative ms-1">
              <RawData :data="propertyRow.item" v-if="$store.state.decrypt.isAdmin()" />
            </div>
            <b-card-header header-tag="header" role="tab" class="border">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center pe-5">
                  <div :style="propertyNumberWidth(
                    (currentPageCart - 1) * perPageCart +
                    (propertyRow.index + 1)
                  )
                    " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                    <h3 class="mb-0 position-relative">
                      {{
                        (currentPageCart - 1) * perPageCart +
                        (propertyRow.index + 1)
                      }}
                    </h3>
                  </div>
                  <div class="text-muted">
                    <h5 class="mb-0">
                      {{ propertyRow.item.name }}
                    </h5>
                    <div>
                      <small class="d-flex align-items-center">{{
                        propertyRow.item.propertyNumber &&
                          propertyRow.item.propertyNumber != "Not Indicated"
                          ? `Property# ${propertyRow.item.propertyNumber}`
                          : "Not Indicated"
                      }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="ms-3">
                  <i title="Remove From Cart" class="bx bx-x font-size-18 text-danger cursor-pointer ms-2 me-2"
                    @click="removeFromCart(propertyRow.item)"></i>
                </div>
              </div>
            </b-card-header>
          </template>
        </b-table>
      </div>
      <div class="row my-2">
        <div v-if="rowsCart > 0" class="col">
          Showing {{ (currentPageCart - 1) * perPageCart + 1 }} -
          {{
            rowsCart > (currentPageCart - 1) * perPageCart + perPageCart
              ? (currentPageCart - 1) * perPageCart + perPageCart
              : rowsCart
          }}
          of {{ rowsCart }}
        </div>
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
              <!-- pagination -->
              <b-pagination v-model="currentPageCart" :total-rows="rowsCart" :per-page="perPageCart"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Main -->
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
      <b-tab @click="byFiltered = false">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-shopping-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Show All</span>
        </template>
        <div v-if="tabIndex == 0" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Un-Assigned Properties</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <transition name="fade">
                    <div v-if="filtered.length > 0" class="d-flex align-items-center">
                      <b-button :title="`Add ${filter.trim() == '' ? '' : 'Searched '
                        }Properties to Cart`" class="me-1" @click="addAllToCart(grouped, currentPage, perPage)"
                        variant="outline-info"><i class="mdi mdi-cart-outline"></i></b-button>
                      <b-button :title="`Remove ${filter.trim() == '' ? '' : 'Searched '
                        }Properties from Cart`" class="me-2" @click="
                          removeAllFromCart(grouped, currentPage, perPage)
                          " variant="outline-danger"><i class="mdi mdi-cart-remove"></i></b-button>
                    </div>
                  </transition>
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-input autocomplete="off" @keyup="currentPage = 1" v-model="filter" type="search"
                        placeholder="Search Property..." class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0">
              <b-table class="propertyTable datatables target-table" thead-class="d-none" :items="grouped"
                :fields="propertyFields" responsive="sm" :per-page="perPage" :current-page="currentPage" sort-by="id"
                :sort-desc="false" :busy="tableBusy" show-empty>
                <template #empty>
                  <b-card-header>
                    <div class="text-center">
                      <div v-if="filter != ''">
                        <i class="fas fa-exclamation-triangle me-2"></i>There
                        are no properties matching your request
                      </div>
                      <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No
                        properties available
                      </div>
                    </div>
                  </b-card-header>
                </template>
                <template #table-busy>
                  <b-card-header>
                    <div class="d-flex justify-content-center align-items-center p-2">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </b-card-header>
                </template>
                <template #cell(name)="propertyRow">
                  <div class="position-relative ms-1">
                    <RawData :data="propertyRow.item" v-if="$store.state.decrypt.isAdmin()" />
                  </div>
                  <b-card-header header-tag="header" role="tab" class="border">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center pe-5">
                        <div :style="propertyNumberWidth(
                          (currentPage - 1) * perPage +
                          (propertyRow.index + 1)
                        )
                          " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                          <h3 class="mb-0 position-relative">
                            {{
                              (currentPage - 1) * perPage +
                              (propertyRow.index + 1)
                            }}
                          </h3>
                        </div>
                        <div class="text-muted">
                          <h5 class="mb-0">
                            {{ propertyRow.item.name }}
                          </h5>
                          <div style="min-width: max-content">
                            <small class="d-flex align-items-center">{{
                              propertyRow.item.propertyNumber &&
                                propertyRow.item.propertyNumber !=
                                "Not Indicated"
                                ? `Property# ${propertyRow.item.propertyNumber}`
                                : "Not Indicated"
                            }}
                              |
                              <a href="javascript: void(0);" class="text-success d-flex align-items-center ms-1" @click="
                                propertyRow.item.visible =
                                !propertyRow.item.visible
                                ">
                                {{ propertyRow.item.visible ? "Hide" : "Show" }}
                                Details
                                <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                  'rotate-90': propertyRow.item.visible,
                                }"></i>
                              </a>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="float-end d-flex align-items-center ms-3">
                        <i v-if="checkCart(propertyRow.item)" title="Add to Cart"
                          class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                          @click="addToCart(propertyRow.item)"></i>
                        <i v-else title="Remove from Cart"
                          class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                          @click="removeFromCart(propertyRow.item)"></i>
                        <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`all-popover-${propertyRow.item.id}`
                          " tabindex="0"></i>
                        <b-popover :target="`all-popover-${propertyRow.item.id}`
                          " triggers="click blur" placement="leftbottom" variant="secondary" custom-class="p-0">
                          <b-list-group class="w-100 fit">
                            <b-list-group-item button action class="d-flex align-items-center text-info" @click="
                              updateItem(propertyRow.item)
                              "><i class="mdi mdi-update font-size-18 me-1"></i>Update
                              Item</b-list-group-item>
                          </b-list-group>
                        </b-popover>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
                    <div v-if="propertyRow.item.visible">
                      <b-card no-body class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                        <Details :key="`all-details-${propertyRow.item.id}`" :propertyRow="propertyRow.item"
                          :ref="`all-details-${propertyRow.item.id}`"></Details>
                        <AssignmentHistory :key="`all-assignment-${propertyRow.item.id}`"
                          :propertyRow="propertyRow.item" :allowAssign="true" :allowEdit="true" :allowTransfer="false"
                          :employeeData="assignmentHistoryEmployeeData" :locationData="assignmentHistoryLocationData"
                          @dropData="assignProperty($event)" :ref="`all-assignment-${propertyRow.item.id}`"
                          @getEmployee="getEmployee($event)" @getLocation="getLocation($event)"></AssignmentHistory>
                        <Attachments :key="`all-attachments-${propertyRow.item.id}`" :propertyRow="propertyRow.item"
                          :ref="`all-attachments-${propertyRow.item.id}`">
                        </Attachments>
                      </b-card>
                    </div>
                  </b-collapse>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing
                {{ (currentPage - 1) * perPage + 1 }}
                -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab @click="byFiltered = true">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-filter-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Filter by PO</span>
        </template>
        <div v-if="tabIndex == 1" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Un-Assigned Properties</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" @keyup="currentPage = 1" v-model="filter" type="search"
                        placeholder="Search Property..." class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptionsLg">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table class="propertyTable datatables target-table" :items="grouped" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                :busy="tableBusy" bordered outlined striped show-empty>
                <template #empty>
                  <b-card-header>
                    <div class="text-center">
                      <div v-if="filter != ''">
                        <i class="fas fa-exclamation-triangle me-2"></i>There
                        are no properties matching your request
                      </div>
                      <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No
                        properties available
                      </div>
                    </div>
                  </b-card-header>
                </template>
                <template #table-busy>
                  <b-card-header>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </b-card-header>
                </template>
                <template #cell(poNumber)="row">
                  <b-card-header header-tag="header" @click="showDtls(row)" class="cursor-pointer border" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <b class="text-white">{{
                          row.value ? `PO# ${row.value}` : "No Recorded PO"
                        }}</b>
                        <div>
                          {{
                            row.item.supplier
                              ? row.item.supplier
                              : "No Recorded Supplier"
                          }}
                        </div>
                      </div>
                      <div>
                        <i class="bx bx-chevron-right rotate font-size-16 cursor-pointer" :class="{
                          'rotate-90': row.item.rotateChevy,
                        }"></i>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse :visible="row.item.showDetails">
                    <div v-if="row.item.showDetails">
                      <b-card no-body class="p-3 shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                        <div class="d-flex justify-content-between mb-3">
                          <div></div>
                          <div class="d-flex float-end">
                            <div class="d-flex align-items-center">
                              <b-button :title="`Add ${filter.trim() == '' ? '' : 'Searched '
                                }Properties to Cart`" class="btn-sm me-1" @click="
                                  addAllToCart(
                                    propertyFiltered(row.item),
                                    row.item.currentPage,
                                    row.item.perPage
                                  )
                                  " variant="outline-info"><i class="mdi mdi-cart-outline"></i></b-button>
                              <b-button :title="`Remove ${filter.trim() == '' ? '' : 'Searched '
                                }Properties from Cart`" class="btn-sm me-2" @click="
                                  removeAllFromCart(
                                    propertyFiltered(row.item),
                                    row.item.currentPage,
                                    row.item.perPage
                                  )
                                  " variant="outline-danger"><i class="mdi mdi-cart-remove"></i></b-button>
                            </div>
                            <div id="tickets-table_filter" class="dataTables_filter me-1">
                              <label class="d-inline-flex align-items-center mb-0">
                                <b-form-input autocomplete="off" v-model="row.item.filter" type="search"
                                  placeholder="Search Property..." class="form-control form-control-sm"></b-form-input>
                              </label>
                            </div>
                            <div id="tickets-table_length" class="dataTables_length">
                              <label class="d-inline-flex align-items-center mb-0">
                                <b-form-select class="form-select form-select-sm" v-model="row.item.perPage" size="sm"
                                  :options="pageOptionsSm">
                                </b-form-select>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="mb-0">
                          <b-table class="propertyTable datatables target-table" thead-class="d-none"
                            :items="propertyFiltered(row.item)" :fields="propertyFields" responsive="sm"
                            :per-page="row.item.perPage" :current-page="row.item.currentPage" sort-by="id"
                            :sort-desc="false" :busy="row.item.tableBusy" show-empty>
                            <template #empty>
                              <b-card-header>
                                <div class="text-center">
                                  <div v-if="row.item.filter != ''">
                                    <i class="fas fa-exclamation-triangle me-2"></i>There are no properties matching
                                    your
                                    request
                                  </div>
                                  <div v-else>
                                    <i class="fas fa-exclamation-triangle me-2"></i>No properties available
                                  </div>
                                </div>
                              </b-card-header>
                            </template>
                            <template #table-busy>
                              <b-card-header>
                                <div class="d-flex justify-content-center align-items-center p-2">
                                  <div class="preloader-component me-2">
                                    <div class="status">
                                      <div class="spinner-chase w-20px h-20px">
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <strong>Loading...</strong>
                                </div>
                              </b-card-header>
                            </template>
                            <template #cell(name)="propertyRow">
                              <div class="position-relative ms-1">
                                <RawData :data="propertyRow.item" v-if="$store.state.decrypt.isAdmin()" />
                              </div>
                              <b-card-header header-tag="header" role="tab" class="border">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="d-flex align-items-center pe-5">
                                    <div :style="propertyNumberWidth(
                                      (currentPage - 1) * perPage +
                                      (propertyRow.index + 1)
                                    )
                                      " class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                      <h3 class="mb-0 position-relative">
                                        {{
                                          (row.item.currentPage - 1) *
                                          row.item.perPage +
                                          (propertyRow.index + 1)
                                        }}
                                      </h3>
                                    </div>
                                    <div class="text-muted">
                                      <h5 class="mb-0">
                                        {{ propertyRow.item.name }}
                                      </h5>
                                      <div style="min-width: max-content">
                                        <small class="d-flex align-items-center">{{
                                          propertyRow.item.propertyNumber &&
                                            propertyRow.item.propertyNumber !=
                                            "Not Indicated"
                                            ? `Property# ${propertyRow.item.propertyNumber}`
                                            : "Not Indicated"
                                        }}
                                          |
                                          <a href="javascript: void(0);"
                                            class="text-success d-flex align-items-center ms-1" @click="
                                              propertyRow.item.visible =
                                              !propertyRow.item.visible
                                              ">
                                            {{
                                              propertyRow.item.visible
                                                ? "Hide"
                                                : "Show"
                                            }}
                                            Details
                                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                              'rotate-90':
                                                propertyRow.item.visible,
                                            }"></i>
                                          </a>
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="float-end d-flex align-items-center ms-3">
                                    <i v-if="checkCart(propertyRow.item)" title="Add to Cart"
                                      class="mdi mdi-cart-outline font-size-18 text-info cursor-pointer me-1"
                                      @click="addToCart(propertyRow.item)"></i>
                                    <i v-else title="Remove from Cart"
                                      class="mdi mdi-cart-remove font-size-18 text-danger cursor-pointer me-1"
                                      @click="removeFromCart(propertyRow.item)"></i>
                                    <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`filter-popover-${propertyRow.item.id}`
                                      " tabindex="0"></i>
                                    <b-popover :target="`filter-popover-${propertyRow.item.id}`
                                      " triggers="click blur" placement="leftbottom" variant="secondary"
                                      custom-class="p-0">
                                      <b-list-group class="w-100 fit">
                                        <b-list-group-item button action class="d-flex align-items-center text-info"
                                          @click="
                                            updateItem(propertyRow.item)
                                            "><i class="mdi mdi-update font-size-18 me-1"></i>Update
                                          Item</b-list-group-item>
                                      </b-list-group>
                                    </b-popover>
                                  </div>
                                </div>
                              </b-card-header>
                              <b-collapse :visible="propertyRow.item.visible" role="tabpanel">
                                <div v-if="propertyRow.item.visible">
                                  <b-card no-body
                                    class="shadow-none mb-0 border-5 border-top-0 border-start-0 border-end-0">
                                    <Details :key="`all-details-${propertyRow.item.id}`" :propertyRow="propertyRow.item"
                                      :ref="`all-details-${propertyRow.item.id}`"></Details>
                                    <AssignmentHistory :key="`all-assignment-${propertyRow.item.id}`"
                                      :propertyRow="propertyRow.item" :allowAssign="true" :allowEdit="true"
                                      :allowTransfer="false" :employeeData="assignmentHistoryEmployeeData
                                        " :locationData="assignmentHistoryLocationData
                                          " @dropData="assignProperty($event)"
                                      :ref="`all-assignment-${propertyRow.item.id}`" @getEmployee="getEmployee($event)"
                                      @getLocation="getLocation($event)"></AssignmentHistory>
                                    <Attachments :key="`all-attachments-${propertyRow.item.id}`"
                                      :propertyRow="propertyRow.item" :ref="`all-attachments-${propertyRow.item.id}`">
                                    </Attachments>
                                  </b-card>
                                </div>
                              </b-collapse>
                            </template>
                          </b-table>
                        </div>
                        <div class="row">
                          <div v-if="propertyRows(row.item) > 0" class="col">
                            Showing
                            {{
                              (row.item.currentPage - 1) * row.item.perPage + 1
                            }}
                            -
                            {{
                              propertyRows(row.item) >
                                (row.item.currentPage - 1) * row.item.perPage +
                                row.item.perPage
                                ? (row.item.currentPage - 1) *
                                row.item.perPage +
                                row.item.perPage
                                : propertyRows(row.item)
                            }}
                            of {{ propertyRows(row.item) }}
                          </div>
                          <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                                <b-pagination v-model="row.item.currentPage" :total-rows="propertyRows(row.item)"
                                  :per-page="row.item.perPage"></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </b-collapse>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <!-- View Cart -->
    <transition name="fade">
      <div v-if="selectedProperties.length > 0" @mouseenter="mouseOverCart = true" @mouseleave="mouseOverCart = false"
        class="position-fixed" style="bottom: 20px; left: 50px">
        <span class="badge bg-danger rounded-pill position-fixed" style="bottom: 55px; left: 85px">{{
          selectedProperties.length }}</span>
        <div title="View Cart" class="avatar-sm mx-auto cursor-pointer" @click="showCart()">
          <span class="avatar-title rounded-circle bg-info">
            <i class="mdi mdi-cart-outline font-size-24" :class="{
              'bx-tada': mouseOverCart == true,
            }"></i>
          </span>
        </div>
      </div>
    </transition>
    <PropertyUpdate 
      ref="propertyupdate"
      @updateData="onUpdateItem($event)"
      @getFundCluster="getFundCluster($event)"
      @getItemCategory="getItemCategory($event)"
      @getSupplier="getSupplier($event)"
      @getUnit="getUnit($event)"
    ></PropertyUpdate>
    <fund-cluster
      ref="fundcluster"
      @dropData="dropFundCluster($event)"
    ></fund-cluster>
    <item-category
      ref="itemcategory"
      @dropData="dropItemCat($event)"
    ></item-category>
    <supplier @dropData="dropSupplier($event)"></supplier>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <Disposal ref="disposal"></Disposal>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.slideUp-enter-active {
  animation: slide-up 0.5s;
}

.slideUp-leave-active {
  animation: slide-up 0.5s reverse;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
